@if (site$ | async; as site) {
  <glxy-page>
    <glxy-page-toolbar>
      <glxy-page-title>
        {{ 'NAVIGATION.TABS.OVERVIEW' | translate }}
      </glxy-page-title>
      <glxy-page-actions>
        @if (editRedirectURL$ | async; as editUrl) {
          <button
            data-action="wordpress-edit-site"
            data-action-group="open-wordpress"
            mat-flat-button
            color="primary"
            (click)="navigateToEditSite(site.siteId, editUrl)"
          >
            <mat-icon>create</mat-icon>
            {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.EDIT_MY_SITE' | translate }}
          </button>
        }
        <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
          <mat-icon>help_outline</mat-icon>
        </a>
      </glxy-page-actions>
    </glxy-page-toolbar>
    <glxy-page-wrapper>
      <div class="app-container center">
        <div class="center">
          <div style="display: flex; align-items: center">
            <div style="flex-basis: 30%">
              <div>
                <app-manage-site
                  [siteId]="site.siteId"
                  [domain]="site.domain"
                  [editURL]="editRedirectURL$ | async"
                  [siteUpdate]="siteUpdate$ | async"
                  [siteUpdateErr]="siteUpdateErr"
                ></app-manage-site>
                <app-manage-template-card [siteId]="site.siteId" [site]="site"></app-manage-template-card>
                <app-purge-cache-card></app-purge-cache-card>
              </div>
            </div>
            <div style="flex-basis: 70%">
              <div
                [class.safari-only-speed-score-margin]="isSafari()"
                [class.non-safari-speed-score-margin]="!isSafari()"
              >
                <app-speed-score [domain]="site.domain" [siteId]="site.siteId"></app-speed-score>
              </div>
            </div>
          </div>
        </div>
      </div>
    </glxy-page-wrapper>
  </glxy-page>
}
